import type { DeepRequired } from '../fixtures.types'

const dependant: DeepRequired<Dependant> = {
  __typename: 'Dependant',
  relationship: 'CHILD',
  id: 'TEST_ID',
  internalHash: null,
  name: null,
  date_of_birth: null,
  dependency_end_date: null,
  relationship_other: null,
  title: null,
}

export default dependant
